module.exports = __webpack_public_path__ + "assets/img/2.9cd6926e.jpg";